export default __webpack_public_path__ + "9e59118463076f060bddb3149c97593f.svg";